module.exports = __webpack_public_path__ + "img/img5.4a0de4e9.png";